module.exports = __webpack_public_path__ + "img/ATM.c2b1ed39.svg";